// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__Hyp0t","icons":"Loader_icons__xKSEO","bouncing":"Loader_bouncing__WJp7S"};